// This file contains map options for VisMap
export const visMapOptions = {
  zoomControl: true,
  mapTypeControl: true,
  streetViewControl: true,
  fullscreenControl: true,
  // Move controls to the right
  zoomControlOptions: { position: 6 }, // RIGHT_BOTTOM
  mapTypeControlOptions: { position: 3 }, // RIGHT_BOTTOM
  streetViewControlOptions: { position: 3 }, // RIGHT_BOTTOM
  fullscreenControlOptions: { position: 3 }, // RIGHT_BOTTOM
};
